"use client"

import { useState } from "react"
import { Handshake } from "lucide-react"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { PayoutQueue } from "@/components/partners/admin/payout-queue"
import { AdminPartnersTab } from "@/components/partners/admin/admin-partners-tab"
import { ProgramSettingsTab } from "@/components/partners/admin/program-settings-tab"
import { useTranslations } from "next-intl"
import { TranslationText } from "@/components/i18n/translation-text"



type AdminTab = "partners" | "payouts" | "settings"

export function PartnerAdminPage() {
  const tUi = useTranslations("Partners.PartnersAdminPartnerAdminPage")

  const [tab, setTab] = useState<AdminTab>("partners")

  return (
    <div className="p-6">
      <div className="mx-auto max-w-6xl space-y-6">
        <div>
          <h1 className="flex items-center gap-2 text-2xl font-semibold"><TranslationText>{tUi.rich("tag0Tag0PartnerProgram", { tag0: () => (<Handshake className="h-5 w-5" />) })}</TranslationText></h1>
          <p className="mt-1 text-sm text-muted-foreground">
            <span key={tUi("partnersTheirReferralLinksAndCommissionThePayout")}>{tUi("partnersTheirReferralLinksAndCommissionThePayout")}</span></p>
        </div>

        <Tabs value={tab} onValueChange={value => setTab(value as AdminTab)}>
          <TabsList>
            <TabsTrigger value="partners"><span key={tUi("partners")}>{tUi("partners")}</span></TabsTrigger>
            <TabsTrigger value="payouts"><span key={tUi("payouts")}>{tUi("payouts")}</span></TabsTrigger>
            <TabsTrigger value="settings"><span key={tUi("settings")}>{tUi("settings")}</span></TabsTrigger>
          </TabsList>

          <TabsContent value="partners" className="mt-4">
            <AdminPartnersTab />
          </TabsContent>
          <TabsContent value="payouts" className="mt-4">
            <PayoutQueue />
          </TabsContent>
          <TabsContent value="settings" className="mt-4">
            <ProgramSettingsTab />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}
